import { Reducer } from 'redux'
import { IAarCombinatiesState } from '../interfaces'
import { CombinatieActions, Actions } from '../actions/aarCombinatiesAction'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { IExtendedKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'

const initialState: IAarCombinatiesState = {
  loading: false,
  locaties: undefined,
  foutmelding: undefined,
}

export const aarCombinatiesReducer: Reducer<
  IAarCombinatiesState,
  CombinatieActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ClearDataRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.ClearDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
      }

    case Actions.GetCombinatieDataRequest:
      return { ...state, loading: true, foutmelding: null, klanten: null }
    case Actions.GetCombinatieDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        locaties: action.success ? mapLocaties(action.payload) : null,
      }

    case Actions.UpdateKoppelingenRequestAction:
      return { ...state, loading: true, foutmelding: null }
    case Actions.UpdateKoppelingenResponseAction:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        locaties: action.success ? mapLocaties(action.payload) : state.locaties,
      }

    case Actions.ChangeKoppelingAction:
      return {
        ...state,
        locaties: updateLocatie(
          action.payload,
          action.value,
          action.canCombine,
          state.locaties
        ),
      }

    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }

  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}

const updateLocatie = (
  record: IExtendedKoppeling,
  value: string,
  canCombine: boolean,
  locaties: ILocatieGlnModel[]
): ILocatieGlnModel[] => {
  return locaties.map(location => {
    if (location.locatieGlnId === record.shipToLocationGlnId) {
      const link = location.koppelingen.find(
        f =>
          f.afleverafspraakLocatieKoppelingId ===
          record.afleverafspraakLocatieKoppelingId
      )

      if (!link) {
        return location
      }

      link.nieuweWaardeMagCombineren = canCombine
      link.nieuweWaardeCombinatie = value
    }

    return location
  })
}

const mapLocaties = (locaties: ILocatieGlnModel[]): ILocatieGlnModel[] => {
  return locaties.map(l => {
    return {
      ...l,
      koppelingen: mapKoppelingen(l.koppelingen),
    }
  })
}

const mapKoppelingen = (
  koppelingen: IExtendedKoppeling[]
): IExtendedKoppeling[] => {
  return koppelingen.map(k => {
    return {
      afleverafspraakLocatieKoppelingId: k.afleverafspraakLocatieKoppelingId,
      ingangsDatumtijd: k.ingangsDatumtijd,
      eindDatumtijd: k.eindDatumtijd,
      combinatie: k.combinatie,
      magCombineren: k.magCombineren,
      nieuweWaardeCombinatie: !k.combinatie ? '' : k.combinatie,
      nieuweWaardeMagCombineren: k.magCombineren,
      klantAfleverAfspraakId: k.klantAfleverAfspraakId,
      klantAfleverafspraak: k.klantAfleverafspraak,
      locatieGlnId: k.shipToLocationGlnId,
      locatieGln: k.shipToLocationGln,
    }
  })
}
